const DEVMODE = process.env.GATSBY_DEVMODE==='1'
const TRACKMODE =  (typeof window !== `undefined`) &&  (typeof window.analytics !== `undefined`) && (typeof window.analytics.track !== `undefined`);
const sha256 = require('js-sha256').sha256;

const PAGETITLE =  ()=>{
  return typeof document !== `undefined` ? document?.title.split(" | ")[0] : "";
}
const PAGEURL =  ()=>{
  return  (typeof window !== `undefined`) ? (window.location.href) : "";
}
const PAGEPATH =  ()=>{
  return  (typeof window !== `undefined`) ? (window.location.pathname) : "";
}
const PAGETYPE =  ()=>{
  return (typeof window !== `undefined`) &&  window.location.href.includes("skin") ? "Skin" : "Hair"
}
const HASH = (string) => {
  return sha256(string)
}


// cast empty string to null for single purchase
const castEvent = (evt)=>{
  if(evt.core_category === ""){
    evt.core_category = null
  }
  if(evt.billing_interval === ""){
    evt.billing_interval = null
  }
  if(evt.shipping_interval === ""){
    evt.shipping_interval = null
  }
  if(evt.subscription_type === ""){
    evt.subscription_type = null
  }
  return evt
}

export const segmentEvent = (eventName= "Marketing CTA Clicked", eventData) => {
  if( TRACKMODE ){
    eventData = castEvent(eventData)

    //NT2-15761 Create Meta Button Click Event for STS LP
    const fireMeta =  (typeof fbq === `function`) && eventName && (eventName.toLowerCase().includes("clicked") || eventName.toLowerCase().includes("added"))
    // NT2-17944 add event_id on the Product Added
    const fireProductAdded =   ["Product Added"].includes(eventName)
    //NT2-19003 [FE] Skin Pixels | Segment Event Updates
    const addBusinessLine = ["Product Viewed", "Product Added"].includes(eventName)

    eventData.page_title = eventData.page_title || PAGETITLE()
    eventData.page_url = eventData.page_url || PAGEURL()
    eventData.path = eventData.path || PAGEPATH()
    eventData.userAgent = (typeof navigator !== `undefined`) ? navigator.userAgent : ''

    if(Array.isArray(eventData.products)){
      eventData.products = eventData.products.map(evt=>{
        return castEvent(evt)
      })
    }
    if(DEVMODE){
      console.log(eventName, eventData)
    }

    if(fireMeta){
      fbq("trackCustom", "Button Click");
    }
    if(fireProductAdded){
      eventData.event_id = +new Date()
      eventData.eventType = "conversion"
      document.cookie = `segment_event_id=${eventData.event_id};path=/;secure`
    }
    if(addBusinessLine){
      eventData.business_line = PAGETYPE()
    }

    window.analytics.track(eventName, eventData)
  }
}

export const identifyEvent = (identity, integrations) => {
  if( TRACKMODE ){
    if(DEVMODE){
      console.log('identifyEvent' , identity, integrations)
    }
    for(let k in identity){
      let val = identity[k]
      if(typeof val === "string"){
        if(k==="email"){
          identity["email_hashed"] = HASH( val)
          if(DEVMODE){
            console.log("adding email_hashed" , val, HASH(val))
          }
        }
        if(k==="telephone" || k==="phone"  ){
          if(val.indexOf("+1")===-1){
            val = "+1" + val
          }
          identity["phone_hashed"] = HASH(val)
          if(DEVMODE){
            console.log("adding phone_hashed" , val, HASH(val))
          }
        }
      }
    }
    if(integrations){
      window.analytics.identify(identity, {integrations})
    } else {
      window.analytics.identify(identity)
    }

  }
}



export const blogPostShareClicked = (page_url, post_categories, post_tags, post_title, social_network) => {
  if(TRACKMODE){
    window.analytics.track("Blog Post Share Clicked", {
      page_url: page_url,
      post_categories: post_categories,
      post_tags: post_tags,
      post_title: post_title,
      social_network: social_network
    })
  }
}

export const videoPlaySegmentEvent = (location, text) => {
  if(TRACKMODE){
    window.analytics.track("Newsroom Video Clicked", {
      page_url: location,
      text: text
    })
  }
}

export const outboundLinkClicked = (destination, page_url, text, type) => {
  if(TRACKMODE){
    window.analytics.track("Outbound Link Clicked", {
      destination: destination,
      page_url: page_url,
      text: text,
      type: type
    })
  }
}

export const marketingCTAClicked = (destination, page_url, text, type) => {
  if(TRACKMODE){
    window.analytics.track("Marketing CTA Clicked", {
      destination: destination,
      page_url: page_url,
      text: text,
      type: type
    })
  }
}

export const dropdownVariantViewed = (variant_name, page_url) => {
  if(TRACKMODE){
    const eventName = `Experiment Viewed`

    window.analytics.track(eventName, {
      experiment_description: "Testing the performance of 3 packs on the PDP",
      experiment_id: "3pack1",
      experiment_name: "3 Pack Core Subscriptions",
      page_url: page_url,
      variant_name: variant_name,
      userAgent: navigator.userAgent
    })
  }
}

export const dropdownProductSelected = (billing_interval, core_category, name, price, product_gender, product_id, shipping_interval, sku, subscription_type, type, variant, purchase_type, isSubscription) => {
  if(TRACKMODE){
    const eventName = `Product Selected`
    const eventData = {
      core_category: core_category,
      name: name,
      price: Math.floor(price),
      product_gender: product_gender,
      product_id: product_id,
      purchase_type: purchase_type || 'Growthplan 1',
      sku: sku,
      type: type,
      variant: variant
    };
    // debugger;
    if(isSubscription){
      eventData.billing_interval = billing_interval;
      eventData.subscription_type = subscription_type;
      eventData.shipping_interval = shipping_interval;
    }
    window.analytics.track(eventName, eventData )
    if(DEVMODE){
      console.log(eventName, eventData)
    }
  }
}

export const productAddedF = (obj) => {
  if( typeof window !== `undefined`){
    if( typeof window.analytics !== `undefined` &&
        typeof window.analytics.track !== `undefined`
    ){
      const eventName = `Product Added`
      const eventData = {
        "category": obj.category,
        "name": obj.name,
        "price": obj.price,
        "product_id": obj.product_id,
        "quantity": 1,
        "quiz_reco": false,
        "sku": obj.sku,
        "source": "pdp",
        "value": obj.value,
        "variant": obj.variant,
        "core_category": obj.core_category,
        "product_gender": obj.product_gender,
        "product_category": obj.product_category,
        "purchase_type": obj.purchase_type
      };
      if(obj.activeOptionIsSubscription){
        eventData.subscription_type = obj.activeOptionSubscriptionType;
        eventData.billing_interval = obj.activeOptionBillingInterval;
        eventData.shipping_interval = obj.activeOptionShippingInterval;
      }
      if(DEVMODE){
        console.log(eventName, eventData)
      }
      window.analytics.track(eventName, eventData)
    }
  }
}

export const dropdownProductViewed = (activeOptionCoreCategory, mainImageUrl, title, activeOptionProductGender) => {
  if(TRACKMODE){
    const mainImage = document.querySelectorAll(".main-pdp-image picture img")[0]
    const mainImageUrl = process.env.GATSBY_MAGENTO_URL + mainImage.getAttribute("src").replace("/", "")
    const eventName = `Product Dropdown Viewed`
    const eventData = {
      category: 'growthplan 1',
      core_category: activeOptionCoreCategory,
      image_url: mainImageUrl,
      name: title,
      product_gender: activeOptionProductGender,
      url: window.location.href
    }

    if(DEVMODE){
      console.log(eventName, eventData)
    }
    window.analytics.track(eventName, eventData)
  }
}

export const selectProductClicked = (coreCategory, name) => {
  if(TRACKMODE){

    const eventName = `Select Product Clicked`
    const eventData = {
      core_category: coreCategory,
      name: name,
      product_gender: window.location.href.indexOf('women') === -1 ? 'Men' : 'Women',
      url: window.location.href,
    }
    if(DEVMODE){
      console.log(eventName, eventData)
    }
    window.analytics.track(eventName, eventData)
  }
}

export const ProductAdded = (opt) => {
  if(TRACKMODE){


    const eventName = "Product Added"
    const eventData = {
      "category": opt.getAttribute("data-category"),
      "name": opt.getAttribute("data-name"),
      "price": parseFloat( opt.getAttribute("data-value") ),
      "product_id": opt.getAttribute("data-productid"),
      "quantity": 1,
      "quiz_reco": false,
      "sku": opt.getAttribute("data-sku"),
      "source": "pdp",
      "url": opt.getAttribute("data-carturl"),
      "value": parseFloat( opt.getAttribute("data-value") ),
      "variant": opt.getAttribute("data-title"),
      "core_category": opt.getAttribute("data-core-category"),
      "subscription_type": opt.getAttribute("data-subscription-type"),
      "billing_interval": opt.getAttribute("data-billing-interval"),
      "shipping_interval": opt.getAttribute("data-shipping-interval"),
      "product_gender": opt.getAttribute("data-product-gender"),
      "product_category": opt.getAttribute("data-product-category"),
      "purchase_type": opt.getAttribute("data-purchase-type")
    }
    if(DEVMODE){
      console.log(eventName, eventData)
    }
    window.analytics.track(eventName, eventData);
  }
}

export const orderDetailsViewed = (order) => {
  if(TRACKMODE){
    const eventName = `Order Details Viewed`
    const eventData = {
      order_entity_id: atob(order.id),
      order_increment_id: order.number,
      page_url: window.location.href,
      page_title: document.title,
    }
    if(DEVMODE){
      console.log(eventName, eventData)
    }
    window.analytics.track(eventName, eventData)
  }
}

export const notificationBarViewed = (notification_title, page_title, message) => {
  return window.analytics.track("Account Notification Shown", {
    notification: notification_title,
    page_url: window.location.href,
    page_title: page_title,
    type: message.type === "error" ? "warning" : "standard"
  })
}

export const notificationBarClicked = (notification_title, page_title, message) => {
  return window.analytics.track("Account Notification Clicked", {
    notification: notification_title,
    page_url: window.location.href,
    page_title: page_title,
    type: message.type === "error" ? "warning" : "standard"
  })
}

export const notificationBarClosed = (notification_title, page_title, message) => {
  return window.analytics.track("Account Notification Closed", {
    notification: notification_title,
    page_url: window.location.href,
    page_title: page_title,
    type: message.type === "error" ? "warning" : "standard"
  })
}


export const accountModuleClicked = (product_name) => {
  return window.analytics.track("Account Module CTA Clicked", {
    destination: "/quiz/",
    module_name: "Hair Quiz",
    module_state: "quiz_not_taken",
    page_title: "My Account",
    product_name: product_name,
    text: "Take the Quiz",
    type: "button"
  })
}

export const accountModuleResultsClicked = (destination, product_name) => {
  return window.analytics.track("Account Module CTA Clicked", {
    destination: destination,
    module_name: "Hair Quiz",
    module_state: "quiz_taken",
    page_title: "My Account",
    product_name: product_name,
    text: "View",
    type: "link"
  })
}

export const hairJourneyCTAClick = (product_name, module_state) => {
  return window.analytics.track("Account Module CTA Clicked", {
    destination: "/quiz/",
    module_name: "Hair Journey",
    module_state: module_state,
    page_title: "My Account",
    product_name: product_name,
    text: "Start Your Hair Journey",
    type: "button"
  })
}

export const hairJourneyLearnMoreClick = (product_name) => {
  return window.analytics.track("Account Module CTA Clicked", {
    destination: "modal - benefits",
    module_name: "Hair Journey",
    module_state: "active_subscription",
    page_title: "My Account",
    product_name: product_name.replace(/\\/g, ""),
    text: "Learn More",
    type: "link"
  })
}

export const hairJourneyTabClick = (text, product_name) => {
  return window.analytics.track("Account Module CTA Clicked", {
    destination: "/customer/account/index/",
    module_name: "Hair Journey",
    module_state: "active_subscription",
    page_title: "My Account",
    product_name: product_name,
    text: text,
    type: "tab"
  })
}

export const subscriptionErrorViewed = (email, user_id) => {
  return window.analytics.track("Account Subscription Error Viewed", {
    email: email,
    page_title: "My Account",
    user_id: user_id
  })
}

export const ppVideoPlayed = () => {
  return window.analytics.track("Video Played", {
    page_url: "/postpartum-story/",
    page_title: "Postpartum Story | Nutrafol",
    video_name: "Grow into your own.",
    userAgent: navigator.userAgent
  })
}

export const ppMarketingCtaClick = () => {
  return window.analytics.track("Marketing CTA Clicked", {
    destination: "/nutrafol-postpartum-for-women/",
    page_url: "/postpartum-story/",
    text: "Shop Now",
    type: "button",
    userAgent: navigator.userAgent
  })
}

export const ppMarketingCtaClickAlt = () => {
  return window.analytics.track("Marketing CTA Clicked", {
    destination: "/nutrafol-postpartum-for-women/",
    page_url: "/postpartum-story/",
    text: "Learn More",
    type: "text",
    userAgent: navigator.userAgent
  })
}

export const ppMarketingCtaClickViewAll = () => {
  return window.analytics.track("Marketing CTA Clicked", {
    destination: "/blog/",
    page_url: "/postpartum-story/",
    text: "View All",
    type: "text",
    userAgent: navigator.userAgent
  })
}

export const ppMarketingCtaClickContinue = (linkPath) => {
  return window.analytics.track("Marketing CTA Clicked", {
    destination: linkPath,
    page_url: "/postpartum-story/",
    text: "Continue Shopping",
    type: "text",
    userAgent: navigator.userAgent
  })
}

export const ppBlogPostClick = (title) => {
  return window.analytics.track("Feature Blog Post Clicked", {
    blog_post: title,
    page_url: "/postpartum-story/",
    page_title: "Postpartum Story - Nutrafol"
  })
}



export const ppProductSelected = (billing_interval, price, product_id, purchase_type, shipping_interval, sku, subscription_type, variant, name) => {
  return window.analytics.track("Product Selected", {
    billing_interval: billing_interval,
    core_category: "Postpartum",
    name: name,
    price: price,
    product_gender: "Women",
    product_id: product_id,
    purchase_type: purchase_type,
    shipping_interval: shipping_interval,
    sku: sku,
    subscription_type: subscription_type,
    type: "shoppability",
    variant: variant,
    userAgent: navigator.userAgent
  })
}

export const ppProductAdded = (billing_interval, name, price, product_category, product_id, purchase_type, shipping_interval, sku, subscription_type, variant, category) => {
  return window.analytics.track("Product Added", {
    billing_interval: billing_interval,
    category: category,
    core_category: "Postpartum",
    name: name,
    price: price,
    product_category: product_category,
    product_gender: "Women",
    product_id: product_id,
    purchase_type: purchase_type,
    quantity: 1,
    quiz_reco: false,
    shipping_interval: shipping_interval,
    sku: sku,
    source: "pp_lp",
    subscription_type: subscription_type,
    value: price,
    variant: variant,
    userAgent: navigator.userAgent
  })
}

export const destressLearnMore = () => {
  return window.analytics.track("Marketing CTA Clicked", {
    destination: "/de-stress-duo/men/",
    page_url: "/nutrafol-core-for-men/",
    text: "Learn More",
    type: "button"
  })
}

export const gutLearnMore = () => {
  return window.analytics.track("Marketing CTA Clicked", {
    destination: "/gut-restore-duo/men/",
    page_url: "/nutrafol-core-for-men/",
    text: "Learn More",
    type: "button"
  })
}

export const hairlineLearnMore = () => {
  return window.analytics.track("Marketing CTA Clicked", {
    destination: "/hairline-defender-duo/men/",
    page_url: "/nutrafol-core-for-men/",
    text: "Learn More",
    type: "button"
  })
}

export const accountErrorViewed = (obj) => {
  return window.analytics.track("Account Error Viewed", obj)
}


export const socialOutboundLinkClick = () => {
  return window.analytics.track("Outbound Link Clicked", {
    destination: "https://wellseek.io/seekher",
    page_url: "/social-mission/",
    text: "Learn More About SeekHer",
    type: "link"
  })
}

export const marketingSocialClick = () => {
  return window.analytics.track("Marketing CTA Clicked", {
    destination: "mailto:pr@nutrafol.com",
    page_url: "/social-mission/",
    text: "Email Us",
    type: "button"
  })
}
